/**
 * A global namespace for `pointermove` event.
 */
const pointermoveEvent = 'pointermove';
export default pointermoveEvent;
